import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import ROUTES from "../../../constants/Routes";
import { MANAGER_CLIENT_ACCESS_TOKEN } from "../../../constants/PreferenceKeys";
import LoginContainer from "./LoginContainer";

const ManagerClientAuth = () => {
    const location = useLocation();
    const query = new URLSearchParams(location.search);
    const clientToken = query.get('clientToken');

    useEffect(() => {
        if (clientToken) {
            localStorage.setItem(MANAGER_CLIENT_ACCESS_TOKEN, 'Bearer ' + clientToken);
            sessionStorage.setItem(MANAGER_CLIENT_ACCESS_TOKEN, 'Bearer ' + clientToken);
            sessionStorage.setItem("IS_MANAGER_IMPERSONATION", "true");
            
            const tabId = crypto.randomUUID();
            sessionStorage.setItem("MANAGER_TAB_ID", tabId);

            const channel = new BroadcastChannel("manager_session");
            channel.postMessage({ type: "new_manager_login", tabId });
            channel.close();

            window.location.href = ROUTES.DASHBOARD;
        }
    }, [clientToken]);

    return (
        <LoginContainer isManagerLogin={true} />
    );
}

export default ManagerClientAuth;
